






import dayjs from "dayjs";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import Tooltip from "./tooltip.vue";
import { timeFromNow } from "../filters";

@Component({
  components: {
    Tooltip,
  },
  filters: {
    timeFromNow,
  },
})
export default class TimeSpan extends Vue {
  @Prop() readonly value!: Date | string;
  @Prop({ default: "DD/MM/YYYY à[s] HH:mm" }) readonly format!: string;

  timeSpan: string | null = null;
  get formated() {
    return dayjs(this.value).format(this.format);
  }
}
